<template>
<div id="edit-newsletter">
  <h2>Edit Bundle '{{ name }}'</h2>

  <bundle-form
    method="PUT"
    :bundleId="bundleId"
  ></bundle-form>
</div>
</template>

<script>
import BundleForm from '@/components/BundleForm'

import BundleStore from '@/stores/BundleStore'

export default {
  data () {
    return BundleStore.state
  },

  computed: {
    actionUrl () {
      return this.apiUrl(this.relativeUrl, true)
    },

    relativeUrl () {
      return '/puzzle_bundles/' + this.bundleId
    }
  },

  components: {
    'bundle-form': BundleForm
  },

  props: ['bundleId'],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet(this.relativeUrl, BundleStore, true)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/BundleEdit.vue